<script lang="ts">
	import { classnames } from './utils';

	let { class: className = '', open = $bindable(false) }: { class?: any; open: boolean } = $props();
</script>

<label class={classnames('burger-button', className)}
	><span></span> <input type="checkbox" bind:checked={open} /></label
>

<style lang="sass">
=visually-hidden ()
	position: absolute
	display: block
	width: 1px
	height: 1px
	margin: -1px
	padding: 0
	overflow: hidden
	border: 0
	clip: rect(0 0 0 0)


:global
	$burger-background-color: transparent
	$burger-active-color: rgba(0, 0, 0, 0.05)
	$burger-line-color: #888

	.burger-button
		background: 0 0 $burger-background-color
		border: 1px solid $burger-line-color
		border-radius: 0.5rem
		justify-content: center
		align-items: center
		width: 3rem
		height: 3rem
		transition: border-color .3s
		display: flex
		cursor: pointer
		&:active
			background-color: $burger-active-color


		span
			transform-origin: 0
			background: $burger-line-color
			border-radius: 3px
			width: 50%
			height: 6%
			min-height: 1px
			transition: background .3s
			display: block
			position: relative
			&:before, &:after
				content: ""
				transform-origin: 0
				background: $burger-line-color
				border-radius: 3px
				width: 100%
				height: 100%
				transition: transform .3s
				display: block
				position: absolute
				left: 0
				transform: rotate(0)

			&:after
				bottom: 0
				margin-bottom: -34.7%
			&:before
				top: 0
				margin-top: -34.7%

		&:has(:checked)
			span
				background: transparent
				&:after
					transform: translate(20%)translateZ(0)rotate(-45deg)
				&:before
					transform: translate(20%)translateZ(0)rotate(45deg)

		input
			@include visually-hidden()
</style>
